/**
 * GridSnapToggle Component
 * Toggle for snap-to-grid functionality
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Grid3X3 } from 'lucide-react';
import { toast } from 'sonner';

export const GridSnapToggle = ({
  snapEnabled,
  setSnapEnabled,
}) => {
  const handleToggle = () => {
    setSnapEnabled(!snapEnabled);
    toast.info(snapEnabled ? 'Snap to grid disabled' : 'Snap to grid enabled');
  };

  return (
    <Button
      variant={snapEnabled ? 'default' : 'ghost'}
      size="sm"
      onClick={handleToggle}
      className={`relative p-2 ${snapEnabled ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/50' : 'text-zinc-400 hover:text-white'}`}
      data-testid="snap-toggle"
      title={snapEnabled ? 'Snap to Grid: ON' : 'Snap to Grid: OFF'}
    >
      <Grid3X3 className="w-5 h-5" />
    </Button>
  );
};

export default GridSnapToggle;
